import { gql } from "@apollo/client";

export const REASSESS_INVOICES = gql`
  mutation reassessInvoices($input: ReassessInvoicesInput!) {
    invoice {
      reassessInvoices(input: $input) {
        invoiceId
        errorMessage
        success
      }
    }
  }
`;
